import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import api from '../services/api';

const OrderConfirmation = () => {
    const location = useLocation();
    const orderData = location.state?.orderData || {};
    const [continueShoppingLink, setContinueShoppingLink] = useState('/category/new-in');

    useEffect(() => {
        const fetchLink = async () => {
            try {
                const res = await api.get('/settings/announcement');
                if (res.continueShoppingLink) {
                    setContinueShoppingLink(res.continueShoppingLink);
                }
            } catch (err) {
                console.error('Failed to fetch continue shopping link', err);
            }
        };
        fetchLink();
    }, []);

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 py-12 bg-white">
            <div className="text-center max-w-md">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <FiCheckCircle className="text-green-600" size={40} />
                </div>
                <h1 className="text-3xl font-medium text-gray-900 mb-4">
                    Thanks for Placing Order!
                </h1>
                {orderData.orderNumber && (
                    <p className="text-gray-700 mb-2">
                        Order #: <span className="font-semibold">{orderData.orderNumber}</span>
                    </p>
                )}
                <p className="text-gray-600 mb-8">
                    Your order has been received and we will process it soon. For any inquiries, please contact our support.
                </p>
            </div>
        </div>
    );
};

export default OrderConfirmation;